/** Breathing room left between the sticky breadcrumb and the target. */
const SCROLL_UP_GAP_PX: number = 16;

/**
 * Scrolls back up to a list's search bar after the reader picks a page, so
 * the new page starts with its controls in view rather than at the top of
 * the document. Only scrolls up: a reader already above the target stays put.
 *
 * Measure before the page change starts loading. Nothing above the target
 * moves, so it holds, though a list that shrinks while loading may clamp the
 * scroll a little short (the target stays in view).
 */
export function scrollUpTo(
    target: HTMLElement | undefined,
    smooth: boolean,
): void {
    if (!target) return;
    // Browsers without overflow-x: clip (iOS < 16) scroll the body rather
    // than the window — see the html/body rule in styles.scss.
    const scrolled: number = window.scrollY || document.body.scrollTop;
    // The breadcrumb sticks to the viewport top on list pages; clear it.
    const stickyBar: HTMLElement | null =
        document.querySelector<HTMLElement>('.vb-breadcrumb');
    const offset: number = (stickyBar?.offsetHeight ?? 0) + SCROLL_UP_GAP_PX;
    const top: number = Math.max(
        0,
        target.getBoundingClientRect().top + scrolled - offset,
    );
    if (scrolled <= top) return;
    const options: ScrollToOptions = {
        top,
        behavior: smooth ? 'smooth' : 'auto',
    };
    document.body.scrollTo(options);
    window.scrollTo(options);
}
